<template>
  <div class="order_finish">
    <div class="pay_result">
      <div class="pay_pic" v-if="returnMas.status==2">
          <img src="@/assets/images/payed_pic.png">
          <p>付款成功</p>
        </div>
        <div class="pay_pic" v-if="returnMas.status==1">
          <img src="@/assets/images/paying_pic.png">
          <!-- <img src="../assets/images/payed_pic.png"> -->
          <p>支付结果确认中</p>
        </div>
       <!--  <div class="massage_tip">
          <p>支付成功</p>
          <p>订单金额：¥<span>185</span></p>
        </div> -->
    </div>
    <div class="color_line"></div>
    <div class="mass_tip" v-show="returnMas">
      <div class="gradient_line"></div>
      
      <!-- <dl>
        <dt>商品名称：</dt>
        <dd>
          {{returnMas.insuranceName}}
        </dd>
      </dl> -->
      <div class="mass_box">
        <h3>{{returnMas.insuranceName}}</h3>
        <!-- <dl>
          <dt>订单日期：</dt>
          <dd>
            {{returnMas.orderDate}}
          </dd>
        </dl> -->
        <dl>
          <dt>被保险人：</dt>
          <dd>
            {{returnMas.insurantName}}
          </dd>
        </dl>
        <dl>
          <dt>订单金额：</dt>
          <dd>
            {{returnMas.price}}元
          </dd>
        </dl>
        <dl>
          <dt>保障期限：</dt>
          <dd>
            {{returnMas.insuredDuration}}
          </dd>
        </dl>
      </div>
       <a class="download_banner" v-show="banner1 && returnMas.status==2" :href="banner1.activityUrl">
          <img :src="banner1.image" alt="">
        </a>
    </div>
   
    <a class="ad_banner" v-show="banner2 && returnMas.status==2" :href="banner2.activityUrl">
      <img :src="banner2.image">
    </a>
    <!-- <a class="download_btn" v-if="returnMas.status==1" @click="download">
      下载APP，管理保费、更可享在线极速理赔
    </a> -->
  </div>
</template>

<script>
// @ is an alias to /src
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 业务api地址
const API_UPDATE_PAYMENTSTATUS = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/updatePaymentStatusPreviewPage.json`;
import base from '../mixins/base';
export default {
  name: 'OrderFinishDemo',
  mixins: [base],
  data() {
    return {
      name: '订单完成预览',
      returnMas:'',
      banner1:'',
      banner2:'',
      count:0

    }
  },
  components:{

  },
  computed: {
    
  },
  methods: {
    download(){
        //console.log(location.search);
      window.location.replace('https://m.health.pingan.com/app/download/download.html')
    },
    //URL查询
    // getQueryValue(key){
    //   let self=this;
    //   var reg = new RegExp("(^|&)"+ key +"=([^&]*)(&|$)");
    //   var r = window.location.search.substr(1).match(reg);
    //   //if(r!=null) return unescape(r[2]);
    //   if(r!=null) return self.escapeHTML(r[2]); 
    //   return null;
    // },
    // //转义html
    // escapeHTML(a){  
    //   a = "" + a;  
    //   return a.replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">").replace(/"/g, "\"").replace(/'/g, "'");
    // },
    async payResult() {
      let self = this;
      let query = self.$route.query;
      // self.insuranceId = query.insid;
      // self.pageId = query.pid
      let params = {"insId":query.insid, "pageId":query.pid};
      //let params = {"userId":'525733', "accessToken":'5NhKvMSHW1/P8IAuNybe2G2cDpOVKN8W',"sceneCode":'2', "orderNo":'52573320200424161451950' ,"insId":101, "pageId":'10'};
      const response = await axios.post(API_UPDATE_PAYMENTSTATUS, params);
      if(response.code==1){
          self.returnMas=response.data;
          let channelPageActivityInfo=response.data.channelPageActivityInfo;
          for(let i=0;i<channelPageActivityInfo.length;i++){
              let cur = channelPageActivityInfo[i];
              if(cur.operationType==2){
                self.banner1 = cur
              }else if(cur.operationType==3){
                self.banner2 = cur
              }
          }

          if(self.returnMas.status==1){
             // var count=0;
             let checkStatus = setInterval(function(){
                 if(self.returnMas.status ==2){
                    checkStatus && clearInterval(checkStatus);
                    //var params={"ticket":ticket,"blackBox":window.fp,"blackBoxType":"SPARTA"};
                 }else{
                    self.count++;
                    if(self.count>3){
                        checkStatus && clearInterval(checkStatus);
                        self.count=0;
                        return;
                    }
                    axios.post(API_UPDATE_PAYMENTSTATUS, params).then((response) => {
                        //console.log("response===---"+self.count,response);
                        if (response.code === 1) {
                          self.returnMas=response.data;
                          let channelPageActivityInfo=response.data.channelPageActivityInfo;
                          for(let i=0;i<channelPageActivityInfo.length;i++){
                              let cur = channelPageActivityInfo[i];
                              if(cur.operationType==2){
                                self.banner1 = cur
                              }else if(cur.operationType==3){
                                self.banner2 = cur
                              }
                          }
                        } else {
                          this.showToast(response.msg)
                        }
                      }).catch((error) => {
                        this.showToast(error)
                      })
                 }
              }, 10000); 
          }
      }else{
          self.showToast(response.msg);
      }
    }
  },
  created() {
    var self=this;
    self.payResult();
  }
}
</script>

<style scoped lang="stylus">
  .order_finish
    .pay_result
      /*background:#FF6F06*/
      background: linear-gradient(#FF6F06, #FF890E)
      background: -webkit-linear-gradient(#FF6F06, #FF890E)
      /*height:2.66rem*/
      height: 2.5rem
      width:100%
      text-align: center
      padding-top: 0.71rem;
      div
        display: inline-block
      .pay_pic
        vertical-align: middle;
        img
          height:.6rem
          vertical-align: middle;
        p
          color: #fff
          font-size: .4rem
          display: inline-block
          margin-left: .22rem
          vertical-align: middle
          font-weight: 500
    .color_line
      background: #DF7300
      height: .17rem
      margin: -0.61rem auto 0
      width: 7.14rem
      border-radius: .17rem
    .mass_tip
        margin: -.08rem .3rem 0
        box-shadow: 0.04rem 0.04rem 0.16rem 0 rgba(0,0,0,0.08);
        border-radius: 0 0 .1rem .1rem
        background: #fff;
        text-align: left
        vertical-align: middle
        padding-bottom: .08rem;
        .gradient_line
          background: linear-gradient(#FFDFC8, #FFFFFF)
          background: -webkit-linear-gradient(#FFDFC8, #FFFFFF)
          height: 0.3rem;
        .mass_box
          padding 0 .3rem .27rem
          h3
            font-size: .3rem
            color: #333
            margin-bottom: .15rem      
          dl 
            position: relative;
            font-size: .26rem
            /*color: #333333*/
            height: .37rem
            dt 
              position: absolute
              left: 0px
              top: 0
              color: #333333
            dd 
              text-align: left
              padding-left: 1.3rem
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
          dl+dl
            margin-top:.15rem
    .download_banner
        /*height: 1.56rem;*/
        width: auto;
        margin: 0 .3rem 
        margin-bottom: .22rem
        border-radius:.1rem
        /*margin-top: 0;*/
        display:block
        /*background:#333*/
        img
          width:100%
          border-radius: 0.1rem
    .ad_banner
        margin: .3rem .3rem 0
        /*background:#D8D8D8*/
        width:6.9rem
        /*height:1.72rem*/
        border-radius:.1rem
        display:block
        /*background:#333*/
        img
          width:100%
          border-radius: 0.1rem
    .download_btn
        display:block
        /*width:6.9rem*/
        height:.88rem
        margin:.41rem .3rem
        border-radius: .88rem
        text-align: center
        color:#fff
        font-size:.3rem
        background: -webkit-linear-gradient(left, #F04D16 , #FE9219)
        background: -o-linear-gradient(right, #F04D16, #FE9219)
        background: -moz-linear-gradient(right, #F04D16, #FE9219) /* Firefox 3.6 - 15 */
        background: linear-gradient(to right,#F04D16, #FE9219)
        line-height: .88rem
</style>
